import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';

class GdsYoutubeService {
    constructor(document) {
        this.document = document;
    }
    get(videoId, videoCaption, contrast) {
        const youTubePlayer = this.document.createElement('gds-youtube-player');
        youTubePlayer.setAttribute('video', videoId);
        youTubePlayer.setAttribute('caption', videoCaption);
        youTubePlayer.setAttribute('contrast', contrast);
        youTubePlayer.setAttribute('autoplay', true);
        return youTubePlayer;
    }
}
GdsYoutubeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
GdsYoutubeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class GdsYoutubeModule {
}
GdsYoutubeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsYoutubeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeModule });
GdsYoutubeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeModule, providers: [GdsYoutubeService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsYoutubeModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [GdsYoutubeService]
                }]
        }] });

export { GdsYoutubeModule, GdsYoutubeService };
